// extracted by mini-css-extract-plugin
export default {"recos":"c3-z","productCardOverride":"d3-z","rowHasBadge":"e3-z"};